<template>
  <v-container id="dashboard" fluid grid-list-lg class="mx-0 pa-0">
    <v-layout row wrap>
      <v-flex md3 sm6 xs12 v-for="(stat,index) in stats.monthlyStats" v-bind:key="index">
        <v-card :class="stat.bgColor" dark>
          <v-container fluid grid-list-sm dark>
            <v-layout class="mt-0 mb-0 mx-1" row wrap>
              <v-flex sm3 hidden-xs-only>
                <v-icon class="mx-0" x-large dark>{{stat.icon}}</v-icon>
              </v-flex>
              <v-flex xs9>
                <div class="silver--text subheading"><h3>{{stat.title}}</h3></div>
              </v-flex>
              <v-flex sm12 xs12>
                <v-layout class="mt-0 mb-0 pa-0" row wrap>
                  <v-flex xs7>
                    <div class="silver--text display-1">{{documentCounts[stat.type]}}</div>
                  </v-flex>
                  <v-flex xs5>
                    <v-btn @click="newDocument(stat.type)" outline class="darkgrey--text darken-1" right flat small>{{stat.action.label}}</v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout class="" row wrap>
      <v-flex xs12>
     <type-ahead></type-ahead>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import TypeAhead from "../components/TypeAhead";
  export default {
    name: "Dashboard",
    data() {
      return {
        stats: {
          monthlyStats: [
            {
              bgColor: "cyan darken-3",
              icon: "library_books",
              title: "Policies",
              data: 2,
              type: "policy",
              action: {
                label: "Add New",
                link: ""
              }
            },
            {
              bgColor: "deep-orange  lighten-3",
              icon: "gavel",
              title: "School Law",
              type: "school law",
              data: 4,
              action: {
                label: "Add New",
                link: ""
              }
            },
            {
              bgColor: "blue-grey darken-1",
              icon: "description",
              title: "Publications",
              type: "publication",
              data: 6,
              action: {
                label: "Add New",
                link: ""
              }
            },
            {
              bgColor: "blue darken-3",
              icon: "list_alt",
              title: "Resources",
              type: "resource",
              data: 6,
              action: {
                label: "Add New",
                link: ""
              }
            },
            {
              bgColor: "blue darken-3",
              icon: "list_alt",
              title: "Journals",
              type: "journalarchive",
              data: 6,
              action: {
                label: "Add New",
                link: ""
              }
            },
            {
              bgColor: "green darken-1",
              icon: "list_alt",
              title: "Leader Newsletter",
              type: "leaderarchive",
              data: 6,
              action: {
                label: "Add New",
                link: ""
              }
            },
            {
              bgColor: "yellow darken-4",
              icon: "list_alt",
              title: "Weekly Advocate",
              type: "weeklyadvocatearchive",
              data: 6,
              action: {
                label: "Add New",
                link: ""
              }
            },
            {
              bgColor: "brown lighten-1",
              icon: "list_alt",
              title: "eClippings",
              type: "eclippingsarchive",
              data: 6,
              action: {
                label: "Add New",
                link: ""
              }
            }
          ]
        }
      };
    },
    methods: {
      newDocument(docType) {
        this.$router.push({name: 'NewDocument', params: {type: docType}})
      }
    },
    computed: {
      documentCounts(){
        return {
          "journalarchive":this.$journalArchives.length,
          "leaderarchive":this.$leaderArchives.length,
          "weeklyadvocatearchive":this.$weeklyAdvocateArchives.length,
          "eclippingsarchive":this.$eclippingsArchives.length,
          "policy":this.$policies.length,
          "resource":this.$resources.length,
          "school law":this.$serviceManuals.length,
          "publication":this.$publications.length,
        }
      }
    },
    components: {
      TypeAhead
    },
    mounted() {
      //this.$cleanupNewDocuments()
      this.$fetchData()
    }
  };
</script>
<style scoped>
  #dashboard .flex {
    margin-bottom: 2px;
  }
</style>
